var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"homePage",attrs:{"fluid":""}},[_c('HomeSection'),_c('QuickFeatures'),_c('Products'),_c('About'),_c('Cta'),_c('Features'),_c('Quote'),_c('SimplePricing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }